import React from 'react';

import ConsumerSearchContext from './ConsumerSearchContext';
import PhoneLookup from './PhoneLookup';
import TokenLookup from './TokenLookup';
import PhoneValidation from './PhoneValidation';
import { RouteComponentProps } from 'react-router-dom';

// Our version of eslint prettier can't parse type re-export for some reason,
// so we'll have to import directly.
import { PropTypes as PhoneLookupPropTypes } from './PhoneLookup/PhoneLookup';
import { PropTypes as TokenLookupPropTypes } from './TokenLookup/TokenLookup';
import { PropTypes as PhoneValidationPropTypes } from './PhoneValidation/PhoneValidation';

export interface FormValues {
  mobilePhone: string | null;
  ssn: string;
  zip: string;
}

interface PhoneLookupType {
  lookupType: 'phoneLookup';
  onSubmit: PhoneLookupPropTypes['onOtpSuccessful'];
}

interface TokenLookupType {
  lookupType: 'tokenLookup';
  onSubmit: TokenLookupPropTypes['onSubmit'];
}

interface PhoneValidationType {
  lookupType: 'phoneValidation';
  onSubmit: PhoneValidationPropTypes['onOtpSuccessful'];
}

type PropTypes = RouteComponentProps & {
  isAccountLookup?: boolean;
  prompt?: boolean;
  skipToPath?: string;
  i18nPrefix: string;
  hasExistingAccount?: boolean;
} & (PhoneLookupType | TokenLookupType | PhoneValidationType);

const SearchComponent: React.FC<PropTypes> = props => {
  switch (props.lookupType) {
    case 'phoneLookup':
      return <PhoneLookup {...props} onOtpSuccessful={props.onSubmit} />;
    case 'tokenLookup':
      return <TokenLookup {...props} />;
    case 'phoneValidation':
      return <PhoneValidation {...props} onOtpSuccessful={props.onSubmit} />;
  }
};

const ReusableConsumerSearch: React.FC<PropTypes> = props => {
  const {
    skipToPath,
    i18nPrefix,
    lookupType,
    isAccountLookup,
    prompt,
    hasExistingAccount,
  } = props;

  return (
    <ConsumerSearchContext.Provider
      value={{
        lookupType,
        i18nPrefix: i18nPrefix === '' ? i18nPrefix : `${i18nPrefix}.`,
        skipToPath,
        prompt,
        isAccountLookup: Boolean(isAccountLookup),
        hasExistingAccount: Boolean(hasExistingAccount),
      }}
    >
      <SearchComponent {...props} />
    </ConsumerSearchContext.Provider>
  );
};

export default ReusableConsumerSearch;
